import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Skeleton/sgds-skeleton";
import { register } from "../../utils/ce-registry";

register("sgds-skeleton", Component);

export default createComponent({
  react: React,
  tagName: "sgds-skeleton",
  elementClass: Component,
  events: {}
});
